import { createRoute } from '@tanstack/react-router';
import { ChatPage } from '../components/chat.tsx';
import { Route as parent } from './signed-in.tsx';
export const Route = createRoute({
  getParentRoute: () => parent,
  path: '/chats/$chatId',
  component: ChatPage,
});
